type LaundryAccessSession = {
  isLoggedIn?: boolean;
  isGuest?: boolean;
  contract?: {
    contractStatus?: string | null;
  } | null;
  reservation?: {
    checkinPerformedAt?: unknown;
  } | null;
};

export function canUseLaundry(session: LaundryAccessSession): boolean {
  return !!session.isLoggedIn
    && !!session.isGuest
    && session.contract?.contractStatus === "active"
    && !!session.reservation?.checkinPerformedAt;
}
